import {ComponentProps, FunctionComponent} from 'react';
// eslint-disable-next-line no-restricted-imports
import {Link as ReactRouterLink} from 'react-router';
import {getTrackedOnClickEvent} from '@/components/tracked-atoms/get-tracked-onclick-event';
import {TrackingProps} from '@/components/tracked-atoms/types';
import {TrackingClickPrefix} from '@/services/analytics/analytics-types';

type LinkProps = ComponentProps<typeof ReactRouterLink> & TrackingProps;

const Link: FunctionComponent<LinkProps> = ({to, onClick, children, trackingKey, trackingText, ...props}) => {
  const handleClick = getTrackedOnClickEvent<HTMLAnchorElement>(trackingKey, onClick, (event, trackingKey) => ({
    click_as: TrackingClickPrefix.NAV,
    click_action: trackingKey,
    click_text: trackingText ?? (event.currentTarget.textContent?.trim() || ''),
    click_url: event.currentTarget.href,
  }));

  return (
    <ReactRouterLink to={to} onClick={handleClick} {...props}>
      {children}
    </ReactRouterLink>
  );
};

export default Link;
